import { render, staticRenderFns } from "./05_ap_formas_pago.vue?vue&type=template&id=3667e85b&scoped=true&"
import script from "./05_ap_formas_pago.vue?vue&type=script&lang=js&"
export * from "./05_ap_formas_pago.vue?vue&type=script&lang=js&"
import style0 from "./05_ap_formas_pago.vue?vue&type=style&index=0&id=3667e85b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667e85b",
  null
  
)

export default component.exports